import React, { useEffect, useState } from 'react';
import { NextPage } from 'next';
import { useDispatch } from 'react-redux';
import { sendAnalytics } from '../redux/analytics/actions';

import { MainLayout } from '../components';

const faqVideos = [
  {
    id: 1,
    type: 'video',
    title: 'Overview of National Rights Registry',
    url: 'https://www.youtube.com/embed/WRVrU_wjpXw?controls=0',
    description:
      'What can you register on the National Rights Registry (nrr.copyright.go.ke) and what are the acceptable formats? Learn more here',
  },
  {
    id: 2,
    type: 'video',
    title: 'How to Register',
    url: 'https://www.youtube.com/embed/lrXKfkbkFnQ?controls=0',
    description:
      'To Support the protection of Copyright works in Kenya, Kenya Copyright Board has created a digital portal nrr.copyright.go.ke where creatives can register their works and get a certificate. This is how to register.',
  },
  {
    id: 3,
    type: 'video',
    title: 'Copyright Registration of Literary Works',
    url: 'https://www.youtube.com/embed/5x4rJlKFZ3I?controls=0',
    description:
      'Are you a writer, poet, publisher or a story teller. Do you know that you can register copyright for your works from the comfort of your home or office using your phone, laptop or computer?',
  },
  {
    id: 4,
    type: 'video',
    title: 'Copyright Registration of Audio Visual Works',
    url: 'https://www.youtube.com/embed/BDF_saTP0iY?controls=0',
    description:
      'Are you a Filmmaker, cinematographer, TV Producer, Vloger, a video creator or creator of any form of Audio Visual content?',
  },
  {
    id: 5,
    type: 'video',
    title: 'Registration of Artistic Works',
    url: 'https://www.youtube.com/embed/g5PEZxLPa7Y?controls=0',
    description:
      'Creators of Artistic works such as Paintings, photographs, drawings, engravings, architecture, maps or handicrafts you can register your works for copyright and get a certificate.',
  },

  {
    id: 6,
    type: 'pdf',
    url: '',
    title: 'Software documentation guidelines for copyright registration.',
    description:
      "Software (computer programs/Apps/websites and related programs) are registered under the copyright category 'Literary work'. One requirements to have the software registered is software documentation.",
  },
];

const QnA = ({ title, url, type, description }) => {
  const [open, setOpen] = useState(false);

  return (
    <div className="mb-6">
      <p onClick={() => setOpen(!open)} className="mb-2 text-xl cursor-pointer">
        {title} <span className="text-sm italic">Click to {open ? 'Close' : 'Open'}</span>
      </p>
      {open && (
        <>
          <p className="mb-2">{description}</p>
          {type === 'video' ? (
            <div
              style={{
                overflow: 'hidden',
                paddingBottom: '56.25%',
                position: 'relative',
                height: 0,
              }}
            >
              <iframe
                width="1280"
                height="720"
                src={url}
                frameBorder="0"
                allowFullScreen
                style={{ left: 0, top: 0, height: '100%', width: '100%', position: 'absolute' }}
              ></iframe>
            </div>
          ) : (
            <div>
              <a
                className="px-6 py-3 text-white bg-indigo-600 rounded-md"
                href="https://registry-certificates.s3.eu-west-2.amazonaws.com/certificate-assets/Sample+documentation+for+software+registration.pdf"
                target="_blank"
                rel="noopener noreferrer"
              >
                View Documentation
              </a>
            </div>
          )}
        </>
      )}
    </div>
  );
};

const FAQPage: NextPage = (props) => {
  const dispatch = useDispatch();

  useEffect(() => {
    console.log(props);

    dispatch(
      sendAnalytics({
        event: 'FAQPage',
        category: 'Navigation',
        meta: {},
      }),
    );
  }, []);

  return (
    <MainLayout>
      <div className="mt-4">
        <div className="px-4 max-width lg:px-20">
          {faqVideos.map(({ id, title, url, description, type }) => (
            <QnA key={id} title={title} url={url} description={description} type={type} />
          ))}
        </div>
      </div>
    </MainLayout>
  );
};

export default FAQPage;
